import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { jobs } from '../data/jobs';

const { FiMapPin, FiDollarSign, FiArrowRight } = FiIcons;

const JobListings = () => {
  return (
    <section id="job-listings" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-5xl lg:text-7xl font-black text-mag-black mb-6 uppercase tracking-tighter leading-none">
              Start Your <span className="text-mag-blue">Career</span>
            </h2>
            <div className="h-4 w-40 bg-mag-green"></div>
          </div>
          <div className="max-w-md">
            <p className="text-xl font-bold text-mag-black/80 leading-relaxed mb-2">
              We’re hiring motivated insulation technicians across Michigan for immediate start.
            </p>
            <p className="text-lg font-black text-mag-blue uppercase tracking-tight">
              If you bring skill and reliability, we bring top-tier pay.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {jobs.map((job, index) => (
            <motion.div 
              key={job.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="group relative bg-white border-4 border-gray-100 rounded-[2.5rem] p-10 flex flex-col hover:border-mag-green transition-all shadow-sm hover:shadow-2xl"
            >
              <h3 className="text-3xl font-black text-mag-black mb-6 uppercase tracking-tight leading-none group-hover:text-mag-blue transition-colors">
                {job.title}
              </h3>
              
              <div className="space-y-4 mb-10">
                <div className="flex items-center space-x-3 font-black text-mag-black uppercase tracking-wide text-sm">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-mag-green" />
                  <span>{job.location}</span>
                </div>
                <div className="flex items-center space-x-3 font-black text-mag-black uppercase tracking-wide text-sm">
                  <SafeIcon icon={FiDollarSign} className="w-5 h-5 text-mag-green" />
                  <span>{job.salary}</span>
                </div>
              </div>

              <Link 
                to={`/job/${job.id}`}
                className="mt-auto bg-mag-black text-white w-full py-5 rounded-2xl font-black text-center uppercase tracking-widest hover:bg-mag-blue transition-all flex items-center justify-center space-x-3"
              >
                <span>View Position</span>
                <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JobListings;